/* vitgem-pop.js — merged interaction + animation engine for Vitgem Shopify (Sense theme) */
(function () {
  "use strict";

  /* ─── helpers ──────────────────────────────────────────────────────────── */
  var reduce   = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var canHover = window.matchMedia && window.matchMedia("(hover: hover)").matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var MOTION = (document.documentElement.getAttribute("data-motion") || "full");

  /* ─── scroll reveal (Source B robust version) ──────────────────────────── */
  var _io = null;
  function ensureIO() {
    if (_io || reduce) return _io;
    _io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); _io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -7% 0px" });
    return _io;
  }

  var GROUPS = [
    [".section-head",    0],
    [".grid-products",   1],
    [".list-products",   1],
    [".value-grid",      1],
    [".how-grid",        1],
    [".compare",         1],
    [".review-grid",     1],
    [".trustrow-inner",  1],
    [".ingr-panel",      0],
    [".subscribe",       0],
    [".faq-list",        1],
    [".cta-band",        0],
    [".flavour-overlay", 1],
    [".pdp-grid",        0],
    [".pdp-strip",       1],
    [".pdp-actives",     0],
    [".pdp-reviews",     0],
    [".pdp-related",     0],
  ];

  function revealInView() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll(".reveal:not(.in), .reveal-stagger:not(.in)").forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) el.classList.add("in");
    });
  }

  var _fallbackBound = false;
  function setupReveal() {
    if (reduce) return;
    var o = ensureIO();
    GROUPS.forEach(function (g) {
      var sel  = g[0];
      var stag = g[1];
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.rev) return;
        el.dataset.rev = "1";
        el.classList.add(stag ? "reveal-stagger" : "reveal");
        if (o) o.observe(el); else el.classList.add("in");
      });
    });
    // reveal items already in viewport right now (covers IO-delayed / prerender)
    revealInView();
    // re-check once fonts+images have loaded
    window.addEventListener("load", revealInView, { once: true });
    // watchdog: guarantee no element stays hidden (print, crawlers, IO failures, background tabs)
    setTimeout(function () {
      document.querySelectorAll(".reveal:not(.in), .reveal-stagger:not(.in)").forEach(function (el) {
        el.classList.add("in");
      });
    }, 600);
    // throttled scroll/resize fallback — time-based, not rAF (rAF pauses in background tabs)
    if (!_fallbackBound) {
      _fallbackBound = true;
      var _last = 0;
      window.addEventListener("scroll", function () {
        var now = Date.now();
        if (now - _last > 80) { _last = now; revealInView(); }
      }, { passive: true });
      window.addEventListener("resize", revealInView, { passive: true });
    }
  }

  /* ─── mobile menu (Source A verbatim) ──────────────────────────────────── */
  function setupMenu() {
    var burger = $("[data-vg-burger]");
    var menu   = $("[data-vg-mobile-menu]");
    if (!burger || !menu) return;
    burger.addEventListener("click", function () {
      var open = menu.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    $$("a", menu).forEach(function (a) {
      a.addEventListener("click", function () { menu.classList.remove("open"); });
    });
  }

  /* ─── FAQ accordion (Source A verbatim) ────────────────────────────────── */
  function setupFaq() {
    $$("[data-vg-faq] .faq-item").forEach(function (item) {
      var q = $(".faq-q", item);
      var a = $(".faq-a", item);
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var open = item.classList.toggle("open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
        a.style.maxHeight = open ? (a.scrollHeight + 40) + "px" : "0px";
      });
    });
  }

  /* ─── cookie consent → Google Consent Mode ─────────────────────────────── */
  function gtagConsent(granted) {
    if (!window.gtag) return;
    var v = granted ? "granted" : "denied";
    try {
      gtag("consent", "update", {
        analytics_storage:  v,
        ad_storage:         v,
        ad_user_data:       v,
        ad_personalization: v
      });
    } catch (e) {}
  }

  // Pandectes is the consent manager; the theme's own banner is no longer rendered.
  // The app records consent through Shopify's Customer Privacy API, which fires
  // visitorConsentCollected — relay that into Consent Mode so GA4 doesn't sit in the
  // denied default forever. A second update is harmless if the app already sends one.
  function bridgeAppConsent() {
    function relay() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== "function") return false;
      try { gtagConsent(cp.analyticsProcessingAllowed()); } catch (e) {}
      return true;
    }
    document.addEventListener("visitorConsentCollected", relay);
    // A returning visitor carries a decision but gets no event, and the privacy API loads
    // async — so poll briefly rather than reading it once and giving up.
    var tries = 0;
    (function attempt() {
      if (relay() || ++tries > 12) return;
      setTimeout(attempt, 300);
    })();
  }

  function setupCookie() {
    var el = $("[data-vg-cookie]");
    if (!el) { bridgeAppConsent(); return; }
    var saved = null;
    try { saved = localStorage.getItem("vg_cookie_consent"); } catch (e) {}
    if (!saved) { setTimeout(function () { el.hidden = false; }, 900); }
    else { el.style.display = "none"; } // already chose — keep hidden even if CSS is cached
    function decide(v) {
      try { localStorage.setItem("vg_cookie_consent", v); } catch (e) {}
      el.hidden = true;
      el.style.display = "none"; // inline style wins over .cookie-banner{display:flex}
    }
    var acceptBtn  = $("[data-vg-cookie-accept]",  el);
    var declineBtn = $("[data-vg-cookie-decline]", el);
    if (acceptBtn) {
      acceptBtn.addEventListener("click", function () {
        decide("accepted");
        gtagConsent(true);
        // let consent-gated analytics (vitgem-analytics.js) fire now
        try { document.dispatchEvent(new Event("visitorConsentCollected")); } catch (e) {}
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener("click", function () {
        decide("declined");
        gtagConsent(false);
      });
    }
  }

  /* ─── formula quiz (Source A verbatim) ─────────────────────────────────── */
  function setupQuiz() {
    var modal   = $("[data-vg-quiz]");
    var overlay = $("[data-vg-quiz-overlay]");
    if (!modal) return;
    var steps = {};
    $$("[data-quiz-step]", modal).forEach(function (s) {
      steps[s.getAttribute("data-quiz-step")] = s;
    });
    var goal = null;
    function show(n) {
      Object.keys(steps).forEach(function (k) { steps[k].hidden = (k !== String(n)); });
    }
    function open() {
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add("open");
        if (overlay) overlay.classList.add("open");
      });
      goal = null;
      show(0);
    }
    function close() {
      modal.classList.remove("open");
      if (overlay) overlay.classList.remove("open");
      setTimeout(function () { modal.hidden = true; }, 300);
    }
    $$("[data-vg-quiz-open]").forEach(function (b) { b.addEventListener("click", open); });
    $$("[data-vg-quiz-close]", modal).forEach(function (b) { b.addEventListener("click", close); });
    if (overlay) overlay.addEventListener("click", close);
    $$("[data-goal]", modal).forEach(function (b) {
      b.addEventListener("click", function () { goal = b.getAttribute("data-goal"); show(1); });
    });
    $$("[data-priority]", modal).forEach(function (b) {
      b.addEventListener("click", function () {
        var pr = b.getAttribute("data-priority");
        $$("[data-result]", modal).forEach(function (r) {
          r.hidden = (r.getAttribute("data-result") !== goal);
        });
        var active = $('[data-result="' + goal + '"]', modal);
        if (active) {
          var tok = $("[data-priority-token]", active);
          if (tok) tok.textContent = pr;
        }
        show(2);
      });
    });
    var back    = $("[data-quiz-back]",    modal); if (back)    back.addEventListener("click",    function () { show(0); });
    var restart = $("[data-quiz-restart]", modal); if (restart) restart.addEventListener("click", function () { goal = null; show(0); });
  }

  /* ─── hero parallax depth (Source B verbatim) ──────────────────────────── */
  var _parallaxBound = false;
  var _parallaxLayers = [
    [".heroC-bottles", 0.13],
    [".heroC h1",      0.05],
    [".heroC .lede",   0.09],
  ];
  function applyParallax() {
    var y = window.scrollY;
    if (y > 1000) return;
    _parallaxLayers.forEach(function (pair) {
      var el = document.querySelector(pair[0]);
      if (el) el.style.translate = "0 " + (y * pair[1]).toFixed(1) + "px";
    });
    var stk = document.querySelectorAll(".heroC .sticker");
    if (stk[0]) stk[0].style.translate = "0 " + (y * -0.16).toFixed(1) + "px";
    if (stk[1]) stk[1].style.translate = "0 " + (y * -0.28).toFixed(1) + "px";
  }
  function setupParallax() {
    if (reduce || _parallaxBound) return;
    _parallaxBound = true;
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { applyParallax(); ticking = false; });
      }
    }, { passive: true });
  }

  /* ─── 3D tilt + glare on product cards (Source B verbatim) ─────────────── */
  function bindTilt(card) {
    if (card.dataset.tilt || !canHover || reduce) return;
    card.dataset.tilt = "1";
    var glare = card.querySelector(".card-glare");
    function onMove(e) {
      var r  = card.getBoundingClientRect();
      var px = (e.clientX - r.left)  / r.width;
      var py = (e.clientY - r.top)   / r.height;
      var ry = (px - 0.5) * 9;
      var rx = (0.5 - py) * 9;
      card.style.transform = "perspective(820px) rotateX(" + rx.toFixed(2) + "deg) rotateY(" + ry.toFixed(2) + "deg) scale(1.015)";
      if (glare) {
        glare.style.setProperty("--gx", (px * 100).toFixed(1) + "%");
        glare.style.setProperty("--gy", (py * 100).toFixed(1) + "%");
      }
    }
    card.addEventListener("pointerenter",  function () {
      glare = card.querySelector(".card-glare");
      card.classList.add("tilting");
    });
    card.addEventListener("pointermove",   onMove);
    card.addEventListener("pointerleave",  function () {
      card.classList.remove("tilting");
      card.style.transform = "";
    });
  }
  function setupTilt() {
    document.querySelectorAll(".pcard").forEach(bindTilt);
  }

  /* ─── PDP: quantity stepper ────────────────────────────────────────────── */
  function setupQtyStepper() {
    $$("[data-vg-qty]").forEach(function (box) {
      if (box.dataset.qtyBound) return;
      box.dataset.qtyBound = "1";
      var input = box.querySelector("[data-vg-qty-input]");
      var disp = box.querySelector("[data-vg-qty-disp]");
      var dec = box.querySelector("[data-vg-qty-dec]");
      var inc = box.querySelector("[data-vg-qty-inc]");
      function get() { return Math.max(1, parseInt((input && input.value) || (disp && disp.textContent) || "1", 10) || 1); }
      function set(n) { n = Math.max(1, n); if (input) input.value = n; if (disp) disp.textContent = n; }
      if (dec) dec.addEventListener("click", function () { set(get() - 1); });
      if (inc) inc.addEventListener("click", function () { set(get() + 1); });
    });
  }

  /* ─── PDP: gallery — hover/keyboard/swipe browsing ──────────────────────── */
  function setupGallery() {
    $$("[data-vg-gallery]").forEach(function (g) {
      if (g.dataset.galBound) return;
      g.dataset.galBound = "1";
      var main = g.querySelector("[data-vg-gallery-main]");
      var counter = g.querySelector("[data-vg-gallery-counter]");
      var thumbs = $$("[data-vg-gallery-thumb]", g);
      var track = g.querySelector("[data-vg-track]");
      var i = 0;
      var syncing = false;   // go() is driving the track — ignore the scroll it causes

      // The one place the gallery moves: source, alt, thumb state, counter.
      function go(n) {
        if (!thumbs.length || !main) return;
        i = (n + thumbs.length) % thumbs.length;
        var t = thumbs[i];
        var src = t.getAttribute("data-src") || (t.querySelector("img") && t.querySelector("img").src);
        if (src) main.src = src;
        // each image carries its own keyword-bearing alt; without this the main image
        // kept announcing slide 1 forever
        var alt = t.getAttribute("data-alt");
        if (alt) main.alt = alt;
        thumbs.forEach(function (x, n2) {
          x.classList.toggle("active", n2 === i);
          x.setAttribute("aria-current", n2 === i ? "true" : "false");
        });
        if (counter) counter.textContent = (i + 1) + " / " + thumbs.length;
        if (track && track.clientWidth) {
          ensureAround(i);
          syncing = true;
          track.scrollTo({ left: i * track.clientWidth, behavior: "auto" });
          // released on the next frame, after the scroll event this just triggered
          requestAnimationFrame(function () { syncing = false; });
        }
      }

      // Fill in a slide's real source. Slide 1 ships with one; the rest wait until they are
      // about to be seen, otherwise a phone pulls the whole set on first paint.
      var slides = track ? $$(".pdp-slide", track) : [];
      function ensure(n) {
        if (n < 0 || n >= slides.length) return;
        var s = slides[n].querySelector("source[data-srcset]");
        if (!s) return;
        s.srcset = s.getAttribute("data-srcset");
        s.removeAttribute("data-srcset");
      }
      function ensureAround(n) { ensure(n - 1); ensure(n); ensure(n + 1); }

      // paint state from the track without scrolling it back — this is the path a real
      // finger takes, so it must not call go()
      function adopt(n) {
        if (n === i || n < 0 || n >= thumbs.length) return;
        i = n;
        thumbs.forEach(function (x, n2) {
          x.classList.toggle("active", n2 === i);
          x.setAttribute("aria-current", n2 === i ? "true" : "false");
        });
        if (counter) counter.textContent = (i + 1) + " / " + thumbs.length;
      }

      if (track) {
        var raf = 0;
        track.addEventListener("scroll", function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            if (!track.clientWidth) return;
            var n = Math.round(track.scrollLeft / track.clientWidth);
            // load neighbours even mid-sync, so a fast swipe never lands on an empty slide
            ensureAround(n);
            if (!syncing) adopt(n);
          });
        }, { passive: true });
        // give the first swipe something to land on without waiting for the network
        var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
        idle(function () { ensure(1); });
      }

      // warm the whole set once so hovering down the strip never waits on the network
      var warmed = false;
      function warm() {
        if (warmed) return;
        warmed = true;
        thumbs.forEach(function (t) {
          var s = t.getAttribute("data-src");
          if (s) { var im = new Image(); im.src = s; }
        });
      }

      thumbs.forEach(function (t, n) {
        t.addEventListener("click", function () { go(n); });
        // mouse hover browses instantly. On touch, pointerenter fires from the tap itself,
        // so those are left to click.
        t.addEventListener("pointerenter", function (e) {
          if (e.pointerType && e.pointerType !== "mouse") return;
          warm();
          go(n);
        });
        t.addEventListener("focus", function () { go(n); });
      });

      var strip = g.querySelector(".pdp-thumbs");
      if (strip) {
        strip.addEventListener("pointerenter", function (e) {
          if (e.pointerType && e.pointerType !== "mouse") return;
          warm();
        });
      }

      g.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { e.preventDefault(); go(i - 1); }
        else if (e.key === "ArrowRight") { e.preventDefault(); go(i + 1); }
      });

      // desktop arrows
      var prev = g.querySelector("[data-vg-gallery-prev]");
      var next = g.querySelector("[data-vg-gallery-next]");
      [prev, next].forEach(function (btn, n) {
        if (!btn) return;
        btn.addEventListener("click", function () { go(n === 0 ? i - 1 : i + 1); });
      });
    });
  }

  /* ─── PDP: One-time vs Subscribe + 1mo/2mo frequency selector ───────────── */
  function setupPlanToggle() {
    $$("[data-vg-plans]").forEach(function (group) {
      if (group.dataset.planBound) return;
      group.dataset.planBound = "1";
      var form = document.getElementById("pdp-add-form");
      var freq = group.querySelector("[data-vg-freq]");
      var subPriceEl = group.querySelector("[data-vg-sub-price]");
      var subSaveEl = group.querySelector("[data-vg-sub-save]");

      // Price and saving move together — showing the monthly saving next to the 2-month
      // price would overstate the discount by a third.
      function showFreq(opt) {
        if (!opt) return;
        var p = opt.getAttribute("data-vg-price");
        var s = opt.getAttribute("data-vg-save");
        if (subPriceEl && p) subPriceEl.textContent = p;
        if (subSaveEl && s) subSaveEl.textContent = "Save " + s + " every delivery";
      }

      function setPlanInput(planId) {
        if (!form) return;
        var existing = form.querySelector('input[name="selling_plan"]');
        if (planId) {
          if (!existing) {
            existing = document.createElement("input");
            existing.type = "hidden";
            existing.name = "selling_plan";
            form.appendChild(existing);
          }
          existing.value = planId;
        } else if (existing) {
          existing.parentNode.removeChild(existing);
        }
      }
      function activeFreqId() {
        var a = group.querySelector("[data-vg-freq-opt].active") || group.querySelector("[data-vg-freq-opt]");
        return a ? a.getAttribute("data-vg-plan-id") : null;
      }
      function activate(btn) {
        $$("[data-vg-plan]", group).forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
      }

      // top-level One-time / Subscribe
      $$("[data-vg-plan]", group).forEach(function (btn) {
        btn.addEventListener("click", function () {
          activate(btn);
          if (btn.getAttribute("data-vg-plan") === "sub") {
            if (freq) freq.hidden = false;
            setPlanInput(activeFreqId());
          } else {
            if (freq) freq.hidden = true;
            setPlanInput("");
          }
        });
      });

      // frequency options (selecting one implies Subscribe)
      $$("[data-vg-freq-opt]", group).forEach(function (opt) {
        opt.addEventListener("click", function () {
          $$("[data-vg-freq-opt]", group).forEach(function (o) { o.classList.remove("active"); });
          opt.classList.add("active");
          var sub = group.querySelector('[data-vg-plan="sub"]');
          if (sub) { activate(sub); if (freq) freq.hidden = false; }
          setPlanInput(opt.getAttribute("data-vg-plan-id"));
          showFreq(opt);
        });
      });

      // Re-seed from the default frequency. Liquid already rendered these values, so this
      // is a no-op on load — it only matters if the active option changes some other way.
      showFreq(group.querySelector("[data-vg-freq-opt].active") || group.querySelector("[data-vg-freq-opt]"));
    });
  }

  /* ─── PDP: multi-buy tiers (sets quantity; auto discount applies at cart) ── */
  function setupMultiBuy() {
    $$("[data-vg-buytiers]").forEach(function (group) {
      if (group.dataset.tierBound) return;
      group.dataset.tierBound = "1";
      var input = document.querySelector("[data-vg-qty-input]");
      $$("[data-vg-tier]", group).forEach(function (btn) {
        btn.addEventListener("click", function () {
          $$("[data-vg-tier]", group).forEach(function (b) { b.classList.remove("active"); });
          btn.classList.add("active");
          if (input) input.value = btn.getAttribute("data-qty") || "1";
        });
      });
    });
  }

  /* ─── sticky header scroll-shadow ──────────────────────────────────────── */
  function setupHeader() {
    var hdr = $("[data-vg-header]");
    if (!hdr || hdr.dataset.hdrBound) return;
    hdr.dataset.hdrBound = "1";
    function onScroll() { hdr.classList.toggle("scrolled", window.scrollY > 8); }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ─── cart bridge: open the drawer from the Pop/OS2 header button ───────── */
  /* Prefers <vitgem-cart-drawer> (sections/vitgem-pop-cart-drawer.liquid, the
     storefront basket); the Sense <cart-drawer> lookup is only a fallback for a
     theme where that section has been removed. Falls through to /cart if neither
     is present, so the button is never a dead end. */
  function setupCartBridge() {
    function setCount(n) {
      $$("[data-vg-cart-count]").forEach(function (el) {
        el.textContent = n;
        el.hidden = (n === 0);
      });
    }
    $$("[data-vg-cart-toggle]").forEach(function (btn) {
      if (btn.dataset.cartBound) return;
      btn.dataset.cartBound = "1";
      btn.addEventListener("click", function (e) {
        var d = document.querySelector("vitgem-cart-drawer") || document.querySelector("cart-drawer");
        if (d && typeof d.open === "function") {
          e.preventDefault();
          d.open(btn);
        } else {
          window.location.href = "/cart";
        }
      });
    });
    // live cart count — subscribe to Sense's pub/sub cart updates if present
    try {
      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          fetch("/cart.js", { headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (c) { setCount(c.item_count); })
            .catch(function () {});
        });
      }
    } catch (e) {}
  }

  /* ─── ingredient tab switcher (NEW) ────────────────────────────────────── */
  function setupTabs() {
    $$("[data-vg-tabs]").forEach(function (container) {
      var tabs   = $$("[data-vg-tab]",   container);
      var panels = $$("[data-vg-panel]", container);
      if (!tabs.length || !panels.length) return;

      function activate(key) {
        tabs.forEach(function (t) {
          var isActive = t.getAttribute("data-vg-tab") === key;
          t.classList.toggle("active", isActive);
          t.setAttribute("aria-selected", isActive ? "true" : "false");
        });
        panels.forEach(function (p) {
          var isActive = p.getAttribute("data-vg-panel") === key;
          p.classList.toggle("active", isActive);
          p.hidden = !isActive;
        });
      }

      // determine initial active tab: prefer one already marked .active, else first
      var initialTab = tabs.find(function (t) { return t.classList.contains("active"); }) || tabs[0];
      if (initialTab) activate(initialTab.getAttribute("data-vg-tab"));

      tabs.forEach(function (t) {
        t.addEventListener("click", function () {
          activate(t.getAttribute("data-vg-tab"));
        });
      });
    });
  }

  /* ─── homepage Subscribe & save / One-time toggle ──────────────────────── */
  function setupSubToggle() {
    $$("[data-vg-subcard]").forEach(function (card) {
      if (card.dataset.subBound) return;
      card.dataset.subBound = "1";
      var buttons = $$("[data-vg-subplan]", card);
      var priceEl = $("[data-vg-subprice]", card);
      var wasEl   = $("[data-vg-sub-was]",  card);
      var saveEl  = $("[data-vg-sub-save]", card);
      if (!buttons.length) return;

      function select(plan) {
        buttons.forEach(function (b) {
          var on = b.getAttribute("data-vg-subplan") === plan;
          b.classList.toggle("active", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
        var onetime = plan === "onetime";
        if (priceEl) {
          var v = priceEl.getAttribute(onetime ? "data-onetime" : "data-sub");
          if (v) priceEl.textContent = v;
        }
        // the "was" strike-through + savings badge only make sense for the subscribe price
        if (wasEl)  wasEl.style.display  = onetime ? "none" : "";
        if (saveEl) saveEl.style.display = onetime ? "none" : "";
      }

      buttons.forEach(function (b) {
        b.addEventListener("click", function () { select(b.getAttribute("data-vg-subplan")); });
      });
    });
  }

  /* ─── kinetic headline word-reveal ─────────────────────────────────────────
     The reveal itself is a self-starting CSS animation now (.kin-word in
     vitgem-pop.css), so nothing here gates whether the headline is visible. This used
     to add a .kin-on class, which meant a headline masked at translateY(115%) stayed
     invisible until this file had downloaded, parsed and run — 904 ms of the homepage's
     LCP was that wait.

     All this does now is split plain-text headlines into per-word spans so they get the
     same effect as the hero, whose words Liquid pre-wraps (that keeps the accent .hl
     span intact). Headlines already wrapped in Liquid need nothing at all. */
  function setupKinetic() {
    $$("[data-vg-kinetic]").forEach(function (el) {
      if (el.dataset.kin) return;
      el.dataset.kin = "1";
      if (reduce) return; // leave text plain, fully visible
      if (el.querySelector(".kin-word")) return; // pre-wrapped by Liquid — CSS handles it
      // plain-text headline: skip if it has other markup we'd clobber
      if (el.children.length > 0) return;
      var text = el.textContent || "";
      if (!text.trim()) return;
      el.innerHTML = text.split(/(\s+)/).map(function (token) {
        if (/^\s+$/.test(token)) return token;
        return '<span class="kin-word"><span>' + token + "</span></span>";
      }).join("");
    });
  }

  /* ─── quick add-to-cart (Pop card/PDP) — mirrors Sense product-form ─────── */
  function setupQuickAdd() {
    $$("form[data-vg-quick-add]").forEach(function (form) {
      if (form.dataset.qaBound) return;
      form.dataset.qaBound = "1";
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("[type=submit]");
        if (btn && btn.disabled) return;
        if (btn) { btn.classList.add("is-added"); setTimeout(function () { btn.classList.remove("is-added"); }, 1100); }
        var cart = document.querySelector("vitgem-cart-drawer") || document.querySelector("cart-drawer") || document.querySelector("cart-notification");
        var fd = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === "function") {
          fd.append("sections", cart.getSectionsToRender().map(function (s) { return s.id; }).join(","));
          fd.append("sections_url", window.location.pathname);
        }
        fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { return; } // add error (e.g. out of stock) — leave page as-is
            if (cart && typeof cart.renderContents === "function") cart.renderContents(res);
            if (cart && typeof cart.open === "function") cart.open(btn);
            else window.location.href = "/cart";
            // update the Pop header count + any other listeners
            try {
              if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "vitgem-pop-quick-add" });
              }
            } catch (e) {}
          })
          .catch(function () { form.submit(); });
      });
    });
  }

  /* Desktop sticky purchase bar: reveal the (mobile) sticky bar on desktop once
     the main Add-to-cart has scrolled out of view, hide it when it returns. CSS
     handles the slide + keeps it always-on for mobile. */
  function setupStickyBuy() {
    var bar = document.querySelector(".pdp-sticky");
    var anchor = document.querySelector("#pdp-add-form") || document.querySelector(".pdp-add");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // reveal only once the CTA has scrolled ABOVE the viewport (been passed),
        // not while it's still below the fold higher up the page
        var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle("is-visible", passed);
      });
    });
    io.observe(anchor);
  }

  /* ─── init ──────────────────────────────────────────────────────────────── */
  function init() {
    // essential interactivity — always runs regardless of MOTION
    setupMenu();
    setupFaq();
    setupCookie();
    setupQuiz();
    setupTabs();
    setupSubToggle();
    setupCartBridge();
    setupQuickAdd();
    setupQtyStepper();
    setupGallery();
    setupPlanToggle();
    setupMultiBuy();
    setupHeader();
    setupStickyBuy();

    // motion-aware features
    if (MOTION !== "off") {
      // reveal runs for "full" and "lean"
      setupReveal();
      // kinetic runs for "full" and "lean"
      setupKinetic();
    }
    if (MOTION === "full") {
      // heavy floating FX only for full motion
      setupParallax();
      setupTilt();
    }
  }

  // boot
  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }

  // re-run after Shopify theme editor section reloads
  document.addEventListener("shopify:section:load", init);

  // public re-init handle (useful after dynamic section injection)
  window.vgPop = init;

})();
